import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './assets/fontawesome/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { init, miniApp } from '@telegram-apps/sdk';

window.popup = function (logLvl, txt) {
  let alert = document.createElement('div');
      alert.style.position = 'fixed';
      alert.style.right = '-250px';
      alert.style.top = '100px';
      alert.style.zIndex = '9999';
      alert.style.transition = 'right 2s';
      alert.classList.add('alert');
      if (logLvl === 'success') {
          alert.classList.add('alert-success');
      }
      if (logLvl === 'danger' || logLvl === 'error' ) {
          alert.classList.add('alert-danger');
      }
      if (logLvl === 'warning') {
          alert.classList.add('alert-warning');
      }
      alert.setAttribute('role', 'alert');
      alert.textContent = txt;
      document.body.appendChild(alert);
      let activeAlert = () => {
          alert.style.right = '25px';
      }
      let hideAlert = () => {
          alert.style.right = '-250px';
      }
      setTimeout(activeAlert, 200);
      setTimeout(hideAlert, 5000);

      alert.addEventListener("click", (e) => {
          e.target.remove();
      })
}




const initializeTelegramSDK = async () => {
  try {
    await init();


    if (miniApp.ready.isAvailable()) {
      await miniApp.ready();
      console.log('Mini App готово');
    }


  } catch (error) {
    console.error('Ошибка инициализации:', error);
  }
};


initializeTelegramSDK();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
